const pillars = [
  {
    icon: 'ri-time-line',
    title: 'Fast Turnaround, Zero Shortcuts',
    body: 'Vacant units cost you money every single day. Our teams are trained to move efficiently through apartment turns, deep cleaning, and painting projects without sacrificing quality. We coordinate scheduling tightly so work begins quickly and finishes on time — helping you minimize vacancy periods and maximize rental income.',
  },
  {
    icon: 'ri-phone-line',
    title: 'Responsive Communication',
    body: 'We know how frustrating it is to chase down contractors for updates. With TurnCraft, you always know what\'s happening. We confirm job start times in advance, provide progress updates during the work, and follow up after completion to make sure you\'re satisfied. A real person picks up the phone — every time.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Clean, Professional Job Sites',
    body: 'We treat every property as if it were our own. Floors are protected before we paint, furniture is covered, and all debris and materials are removed when we leave. You won\'t find paint drips on your baseboards or cleaner residue in your bathrooms. We leave units in better condition than we found them — that\'s the TurnCraft standard.',
  },
  {
    icon: 'ri-hand-coin-line',
    title: 'Straightforward, Honest Pricing',
    body: 'No surprise invoices. No upselling on services you don\'t need. Before any work begins, we walk the property with you, assess the scope, and provide a clear, itemized quote. What we quote is what you pay. Our pricing is competitive for the Northern New Jersey market, and our quality consistently exceeds what you\'d get from lower-cost alternatives.',
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-end mb-16">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-award-line text-orange-500"></i>
              <span className="text-xs uppercase tracking-wider text-orange-500 font-semibold">
                Why TurnCraft
              </span>
            </div>
            <h2
              className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              The Standard Every Property Deserves
            </h2>
          </div>
          <div>
            <p className="text-base lg:text-lg text-gray-600 leading-relaxed">
              There is no shortage of painting and cleaning companies in New Jersey. What sets TurnCraft Property Solutions apart is a genuine commitment to the property management industry — we understand your timelines, your tenants, and what it takes to protect the value of your investment. Here is why property managers across Morris, Essex, and Union Counties choose us again and again.
            </p>
          </div>
        </div>

        {/* Pillars Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {pillars.map((pillar) => (
            <article key={pillar.title} className="bg-gray-50 rounded-3xl p-8">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500/10 rounded-2xl mb-6">
                <i className={`${pillar.icon} text-2xl text-orange-500`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{pillar.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{pillar.body}</p>
            </article>
          ))}
        </div>

        {/* Bottom text block */}
        <div className="mt-16 bg-orange-500 rounded-3xl p-10 lg:p-14 grid lg:grid-cols-3 gap-8 items-center">
          <div className="lg:col-span-2">
            <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4">
              Built for Property Managers. Trusted by Owners.
            </h3>
            <p className="text-white/90 text-base leading-relaxed">
              Whether you manage a single rental unit or a portfolio of multi-family buildings, TurnCraft Property Solutions scales to meet your needs. We have worked with individual landlords refreshing one apartment at a time, and with commercial property management firms coordinating large-scale interior painting across multiple buildings simultaneously. Our systems, our crew, and our process are built to handle both — and everything in between.
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <div className="bg-white/20 rounded-2xl p-6 text-center">
              <p className="text-4xl font-bold text-white">100%</p>
              <p className="text-white/85 text-sm mt-1">Satisfaction focus on every job</p>
            </div>
            <div className="bg-white/20 rounded-2xl p-6 text-center">
              <p className="text-4xl font-bold text-white">3</p>
              <p className="text-white/85 text-sm mt-1">Counties served across Northern NJ</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
